<template>
  <!-- 首页-数据看板-专利寿命分布-柱状图 -->
	<div ref="myChart" :style="{margin: '0 auto',width: '100%', height: '100%'}"></div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			echartDatas: {
				type: Array,
				default() {
					return []
				}
			}
		},
		components: {
		},
		created() {
		},
		mounted() {
			this.drawChart()
		},
		methods: {
			drawChart() {
				// this.$refs.myChart.removeAttribute("_echarts_instance_")
				// document.getElementById('echartLine').removeAttribute("_echarts_instance_");
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(this.$refs.myChart, 'light')
				let echartDatas = this.echartDatas
        let xAxisDatas = []
        let seriesDatas = []
        for (let i = 0; i < echartDatas.length; i++) {
          xAxisDatas.push(echartDatas[i].name)
          seriesDatas.push(echartDatas[i].value)
        }
				// 指定图表的配置项和数据
				let option = {
					grid: {
            left: '0%',
            right: '0%',
            bottom: '3%',
            containLabel: true
          },
          title: {
            text: '专利寿命分布',
            x: 'center',
            textStyle: {
              fontSize: 18,
              fontWeight: 'normal',
              color: '#FFFFFF'
            }
          },
          xAxis: {
            type: 'category',
            data: xAxisDatas,
            // data: ['<1年', '1年', '2-3年', '4-5年', '6-10年', '11-15年', '15年+'],
            axisLabel: {
              textStyle: {
                fontSize: 14,
                fontWeight: 'normal',
                color: '#FFFFFF'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 1.5
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: false,
              textStyle: {
                fontSize: 10,
                fontWeight: 'normal',
                color: '#FFFFFF'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                width: 1.5
              }
            },
            splitNumber: 3,
            splitLine: {
              show: true,
              lineStyle: {
                width: 0.4,
                color: '#D9D9D9',
                type: 'dashed'
              }
            }
          },
          series: [
            {
              data: seriesDatas,
              // data: ['7495', '23549', '33243', '8874', '1023', '155', '258'],
              type: 'bar',
              label: {
                show: true,
                position: 'top',
                textStyle: {
                fontSize: 12,
                fontWeight: 'normal',
                color: '#FFC000'
                }
              },
              itemStyle: {
                color: '#5470c6'
              }
            }
          ]
				}
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option)
			}
		},
		watch: {
			echartDatas: {
				handler() { // val, oldVal
					// console.log('当数量变化时重新绘制图表')//但是这两个值打印出来却都是一样的
					this.drawChart()
				}
			}
		}
	}
</script>

<style>
</style>
